import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M11 7h4","key":"svg-1"}],["path",{"d":"M9 11h2","key":"svg-2"}],["path",{"d":"M9 15h4","key":"svg-3"}],["path",{"d":"M3 3l18 18","key":"svg-4"}]]

const IconNotesOff = createReactComponent('outline', 'notes-off', 'NotesOff', __iconNode);

export default IconNotesOff;